import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NatSpecCategory} from '../models/categories.model';

@Injectable()
export class CategoriesService {
  constructor(private _api: ApiService,
              private _http: HttpClient) {
  }

  public getCategories(): Observable<any> {
    return this._api.get('/productCategories');
  }
  public updateCategory(body: NatSpecCategory, categoryId: number): Observable<any> {
    return this._api.put('/productCategories/' + categoryId, body);
  }
  public newCategory(body: any): Observable<any> {
    return this._api.post('/productCategories', body);
  }

}
